import { render, staticRenderFns } from "./FormNumberItem.vue?vue&type=template&id=0b4f504e&scoped=true"
import script from "./FormNumberItem.vue?vue&type=script&lang=js"
export * from "./FormNumberItem.vue?vue&type=script&lang=js"
import style0 from "./FormNumberItem.vue?vue&type=style&index=0&id=0b4f504e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4f504e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b4f504e')) {
      api.createRecord('0b4f504e', component.options)
    } else {
      api.reload('0b4f504e', component.options)
    }
    module.hot.accept("./FormNumberItem.vue?vue&type=template&id=0b4f504e&scoped=true", function () {
      api.rerender('0b4f504e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/commonPage/components/tableComp/formItems/FormNumberItem.vue"
export default component.exports